import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IReview,
  IReviewListRequest,
  IReviewListResponse,
  IUpdateReviewStatus
} from 'models/review'

const buildParams = ({ skip, limit, statuses, seller_id }: IReviewListRequest) => {
  const params = new URLSearchParams()
  params.append('skip', skip)
  params.append('limit', limit)

  if (statuses?.length) {
    params.append('statuses', statuses.join(','))
  }

  if (seller_id) {
    params.append('seller_id', seller_id)
  }

  return params.toString()
}

export const reviewsApi = {
  getList(
    request: IReviewListRequest
  ): Promise<AxiosResponse<IReviewListResponse>> {
    return privateApi.get<IReviewListResponse>(
      `admin/reviews?${buildParams(request)}`
    )
  },

  getMyList(
    request: IReviewListRequest
  ): Promise<AxiosResponse<IReviewListResponse>> {
    return privateApi.get<IReviewListResponse>(
      `review/v2/my?${buildParams(request)}`
    )
  },

  updateStatus(
    id: string,
    data: IUpdateReviewStatus
  ): Promise<AxiosResponse<IReview>> {
    return privateApi.patch<IReview>(`admin/reviews/${id}/status`, data)
  }
}
